export default __webpack_public_path__ + "images/usd_c47a76.svg";